// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;My soul waits for the Lord,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;more than the night watch for the morning,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;more than the night watch for the morning.<br> </p> </div></div>";
// Exports
module.exports = code;